  <!-- list of checkboxes with all to toggle all of them -->
  <div>
    <h3 class="pageHeader">Assign to:</h3>
    <div class="specialCheckbox">
      <mat-checkbox
        class="example-margin"
        [checked]="checkedAllStandards()"
        [indeterminate]="partiallyComplete()"
        (change)="update($event.checked)"
      >
        All Standards
      </mat-checkbox>
    </div>
  </div>
  <div class="standardsListContainer">
    <div>
      <ng-scrollbar style="height: 200px;">
        <div class="standardsList">
          @for (group of groups(); track group.requestKey; let i = $index) {
            <mat-expansion-panel  class="mat-elevation-z0">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-checkbox
                    [checked]="group.checked"
                    (change)="update($event.checked, i)"
                    [indeterminate]="group.intermediate"
                    class="ellipsisCheckbox"
                  >
                    {{group.name}}
                    @if(group.description){
                      <span class="description"> - {{group.description}}</span>
                    }
                  </mat-checkbox>
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if( group.standards.length) {
                <div class="standardSubList">
                  @for (standard of group.standards; track standard.requestKey; let j = $index) {
                    <div>
                      <mat-checkbox
                        [checked]="standard.checked"
                        (change)="update($event.checked, i, j)"
                        class="ellipsisCheckbox"
                      >
                        {{standard.name}}
                        @if(standard.description){
                          <span class="description"> - {{standard.description}}</span>
                        }
                      </mat-checkbox>
                    </div>
                  }
                </div>
              }
            </mat-expansion-panel>
          }
        </div>
      </ng-scrollbar>
    </div>
  </div>
